import { useMutation } from '@common-fe/common-fe';

import { api } from '@/api';
import { API_URL, IUserConfirmForgotPasswordDto } from '@/dtos';

interface ResetPasswordProps {
  body: IUserConfirmForgotPasswordDto;
  linkId: string;
};

const useResetPasswordQuery = () => {
  const { mutateAsync, isLoading } = useMutation((props: ResetPasswordProps) => api.post<{ valid?: boolean }>(API_URL.PASSWORDS_RESET, props.body, {
    params: { link_id: props.linkId },
  }));

  return {
    resetPasswordQuery: mutateAsync,
    isResetPasswordLoading: isLoading,
  };
};

export default useResetPasswordQuery;
